import { createSlice } from '@reduxjs/toolkit';
import { UserStateType } from 'src/types/user';
import { formatServiceCodes } from './functions';
import { PASSWORD_CHANGED_RELOGIN_MESSAGE } from 'src/utils/passwordChangedLogout';

const initialState: UserStateType = { data: null, loading: false, loadingEdit: false, error: false, serviceCodes: [], passwordChangedRelogin: false };

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        getUserFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getUserFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getUserFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        getProviderServiceCodesFetch: (state, action) => {
            state.error = false;
        },
        getProviderServiceCodesFetchSuccess: (state, action) => {
            state.serviceCodes = formatServiceCodes(action.payload);
        },
        getProviderServiceCodesFetchFailure: (state, action) => {
            // service codes are non-blocking; must not flip user.error (would show login after successful ui-data)
        },
        updateUserFetch: (state, action) => {
            state.loadingEdit = true;
        },
        updateUserFetchSuccess: (state, action) => {
            if (typeof state.data === 'object') {
                state.data = { ...state.data, ...action.payload, permissions: state.data?.permissions };
            }
            if (action.payload?.message === PASSWORD_CHANGED_RELOGIN_MESSAGE) {
                state.passwordChangedRelogin = true;
            }
            state.loadingEdit = false;
        },
        updateUserFetchFailure: (state, action) => {
            state.loadingEdit = false;
        },
    },
});

export const {
    getUserFetch,
    getUserFetchSuccess,
    getUserFetchFailure,
    getProviderServiceCodesFetch,
    getProviderServiceCodesFetchSuccess,
    getProviderServiceCodesFetchFailure,
    updateUserFetch,
    updateUserFetchSuccess,
    updateUserFetchFailure,
} = userSlice.actions;

export default userSlice.reducer;
